.wrap {
  position: absolute;
  left: 50%;
  bottom: 88px;
  transform: translateX(-50%);
  z-index: 7;
  background: rgba(14, 16, 20, 0.92);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 14px 18px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 240px;
  text-align: center;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.actions button {
  border: 0;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 8px 14px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
}

.primary {
  background: linear-gradient(135deg, #e11d2e, #ff4d5a) !important;
}
